export default __webpack_public_path__ + "static/media/RC-GitHub-Inicial.fb26433d.png";